module.exports = __webpack_public_path__ + "static/img/china1.1a85f4c3.png";